interface StringViewerProps {
  value: string;
}

export function StringViewer({ value }: StringViewerProps) {
  return <span className='text-neutral-950 text-sm truncate text-nowrap'>{String(value)}</span>;
}
